import * as Sentry from "@sentry/react";
import { Config } from "./config";

const isProd = process.env.NODE_ENV === "production";

Sentry.init({
  dsn: Config.SENTRY_DSN,
  tracesSampleRate: 1.0,
  debug: !isProd,
  replaysOnErrorSampleRate: 0,
  replaysSessionSampleRate: 0,
  release: process.env.SENTRY_RELEASE,
  integrations: [],
});
